type EmptyCellDisplay = {
  className: string;
  text: string;
};

type ManualScreenerTextFormatter = (value: unknown) => HTMLDivElement;

export type ManualScreenerTableFormatters = {
  name: ManualScreenerTextFormatter;
  description: ManualScreenerTextFormatter;
  screenType: ManualScreenerTextFormatter;
  country: ManualScreenerTextFormatter;
  owner: ManualScreenerTextFormatter;
};

const OPTIONAL_TEXT_CLASS = "text-gray-600 dark:text-gray-400";
const EMPTY_TEXT_CLASS = "text-gray-400 dark:text-gray-500 italic";

function createTextCell(
  value: unknown,
  className: string,
  emptyDisplay?: EmptyCellDisplay,
): HTMLDivElement {
  const cell = document.createElement("div");
  const useEmptyDisplay = emptyDisplay !== undefined && !value;

  cell.className = useEmptyDisplay ? emptyDisplay.className : className;
  cell.textContent = useEmptyDisplay ? emptyDisplay.text : String(value ?? "");

  return cell;
}

export const manualScreenerTableFormatters: ManualScreenerTableFormatters = {
  name: (value: unknown): HTMLDivElement =>
    createTextCell(value, "font-medium text-gray-900 dark:text-white"),
  description: (value: unknown): HTMLDivElement =>
    createTextCell(value, OPTIONAL_TEXT_CLASS, {
      className: EMPTY_TEXT_CLASS,
      text: "No description",
    }),
  screenType: (value: unknown): HTMLDivElement =>
    createTextCell(value, OPTIONAL_TEXT_CLASS, {
      className: EMPTY_TEXT_CLASS,
      text: "None",
    }),
  country: (value: unknown): HTMLDivElement =>
    createTextCell(value, OPTIONAL_TEXT_CLASS, {
      className: EMPTY_TEXT_CLASS,
      text: "None",
    }),
  owner: (value: unknown): HTMLDivElement =>
    createTextCell(value, "text-gray-700 dark:text-gray-300"),
};

declare global {
  interface Window {
    manualScreenerTableFormatters: ManualScreenerTableFormatters;
  }
}
